import { inheritsLoose as _inheritsLoose, wrapNativeSuper as _wrapNativeSuper } from '../_virtual/_rollupPluginBabelHelpers.js';

var BaseError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(BaseError, _Error);

  function BaseError(message) {
    var _this;

    var trueProto = (this instanceof BaseError ? this.constructor : void 0).prototype;
    _this = _Error.call(this, message) || this;
    _this.__proto__ = trueProto;
    return _this;
  }

  return BaseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { BaseError };
//# sourceMappingURL=error.esm.js.map
